import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Search, ScanBarcode, Sparkles, CloudOff } from 'lucide-react';

export const POSCatalogToolbar = ({
  search, onSearchChange, isOffline, offlineReady, cachingProducts,
  onCacheProducts, onOpenAiSearch, onBarcodeScan,
}) => (
  <div className="flex items-center flex-wrap gap-2 shrink-0">
    <div className="relative flex-1 min-w-[140px]">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder={isOffline ? 'Search cached products...' : 'Search medicines... (name, generic, barcode)'}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10 h-11"
        autoFocus
        data-testid="pos-search-input"
      />
    </div>
    <Button
      variant="outline"
      size="sm"
      className="h-11 gap-1.5 px-3 border-violet-300 bg-gradient-to-r from-violet-50 to-fuchsia-50 hover:from-violet-100 hover:to-fuchsia-100 text-violet-700 dark:from-violet-950/40 dark:to-fuchsia-950/40 dark:text-violet-300 dark:border-violet-800"
      onClick={onOpenAiSearch}
      disabled={isOffline}
      data-testid="pos-ai-search-btn"
      title="AI search by symptom, condition, or generic name"
    >
      <Sparkles className="h-4 w-4" />
      <span className="hidden xl:inline">AI Search</span>
    </Button>
    <div className="relative w-36 xl:w-40">
      <ScanBarcode className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Scan barcode..."
        className="pl-10 h-11"
        onKeyDown={(e) => { if (e.key === 'Enter') { onBarcodeScan(e.target.value); e.target.value = ''; } }}
        data-testid="barcode-input"
      />
    </div>
    {isOffline && offlineReady && (
      <Badge variant="outline" className="gap-1.5 h-11 px-3 border-amber-500/50 text-amber-600">
        <CloudOff className="h-3.5 w-3.5" /> Offline
      </Badge>
    )}
  </div>
);
